module.exports = __webpack_public_path__ + "static/media/background.ec7ac723.jpg";